import React from "react";

const Footer = () => {
  const footerContainer = {
    backgroundColor: "#f5f5f5",
    borderTop: "1px solid #e0e0e0",
    borderRadius: "50px",
    marginTop: "40px",
    fontFamily: "Roboto,Manrope",
    lineHeight: "1.5",
  };
  const bottomNoteStyle = {
    marginTop: "24px",
    fontSize: "14px",
    color: "#666",
    textAlign: "center",
  };
  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "8px 0",
    fontSize: "16px",
    maxWidth: "400px",
    marginLeft: "auto",
    marginRight: "auto",
  };

  const labelStyle = {
    fontFamily: "Roboto,Manrope",
    fontSize: "18px",
    textAlign: "left",
    flex: 1,
  };

  const valueStyle = {
    flex: 2,
    textAlign: "right",
  };

  return (
    <footer style={footerContainer}>
      <h3
        style={{
          marginBottom: "5px",
          fontSize: "30px",
          textAlign: "center",
          fontFamily: "Roboto,Manrope",
        }}
      >
        Contact Us
      </h3>

      <div style={rowStyle}>
        <span style={labelStyle}>📧 Email </span>
        <span style={valueStyle}>
          <a
            href="mailto:info@keelis.com"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
              fontFamily: "Roboto,Manrope",
            }}
          >
            info@keelis.com
          </a>
        </span>
      </div>

      <div style={rowStyle}>
        <span style={labelStyle}>📞 Phone </span>
        <span style={valueStyle}>
          <a
            href="tel:+914422299222"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
              fontFamily: "Roboto,Manrope",
            }}
          >
            +91 44 222 99 222
          </a>
        </span>
      </div>

      <div style={rowStyle}>
        <span style={labelStyle}>🏢 Company </span>
        <span style={valueStyle}>
          <a
            href="https://www.keelis.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
              fontFamily: "Roboto,Manrope",
            }}
          >
            Keel Info Solution Private Limited
          </a>
        </span>
      </div>
      <div
        style={{
          ...rowStyle,
          alignItems: "flex-start",
        }}
      >
        <span style={labelStyle}>📍Address </span>
        <span style={{ flex: 2, textAlign: "left" }}>
          <a
           
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: 2,
              textAlign: "left",
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
              fontFamily: "Roboto,Manrope",
            }}
          >
            2nd Floor, Santo Complex, No: 73, Agaram Main Rd, ESIC Nagar, Tiruvanchery, Tambaram East, Chennai, Tamil Nadu – 600126
          </a>
        </span>
      </div>
      <div style={bottomNoteStyle}>
        Powered by{" "}
        <a
          href="https://www.keelis.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "#1976d2", fontWeight: 500 }}
        >
          Keelis
        </a>
        <br />© 2025, Hrms. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
